module.exports = __webpack_public_path__ + "static/media/barcode-green.c67c5d5f.svg";